import React from "react";

import { EditButton, List as RaList, TextField } from "react-admin";

import { useTheme } from "@material-ui/core";

import ResponsiveList from "../components/lists/ResponsiveList";
import { useListStyles } from "../components/lists/useStyles";
import perPage from "../utils/per-page";
import Actions from "./Actions";
import BulkActionButtons from "./BulkActionsButtons";
import CloneButton from "./buttons/CloneButton";
import BookmakerField from "./fields/BookmakerField";
import BookmakerTypeField from "./fields/BookmakerTypeField";
import EventField from "./fields/EventField";
import ItemsField from "./fields/ItemsField";
import UserField from "./fields/UserField";
import Filters from "./Filters";

const List = (props) => {
	const classes = useListStyles();
	const theme = useTheme();
	return (
		<RaList
			{...props}
			classes={classes}
			actions={<Actions />}
			filters={<Filters />}
			filterDefaultValues={{ type: "none" }}
			perPage={perPage()}
			sort={{ field: "id", order: "DESC" }}
			bulkActionButtons={<BulkActionButtons />}
		>
			<ResponsiveList
				mobileHeader={
					<React.Fragment>
						<EventField
							source="event.name"
							variant="h6"
							style={{ fontWeight: "bold" }}
						/>
						<ItemsField
							source="items"
							style={{ paddingLeft: theme.spacing(2) }}
						/>
					</React.Fragment>
				}
				mobileBody={
					<React.Fragment>
						<BookmakerTypeField source="bookmaker_type.name" />
						<BookmakerField source="bookmaker.name" />
						<UserField source="user.name" variant="body1" />
					</React.Fragment>
				}
				mobileActions={
					<React.Fragment>
						<EditButton />
					</React.Fragment>
				}
			>
				<TextField source="id" label="ID" style={{ fontWeight: "bold" }} />
				<EventField source="event.name" />
				<BookmakerTypeField source="bookmaker_type.name" />
				<BookmakerField source="bookmaker.name" />
				<UserField source="user.name" />
				<ItemsField source="items" />
				<EditButton />
				<CloneButton color="secondary" />
			</ResponsiveList>
		</RaList>
	);
};
export default List;
